var PasswordResetEnum = /* @__PURE__ */ ((PasswordResetEnum2) => {
  PasswordResetEnum2["PASSWORD_RESET_FORM"] = "password-reset--form";
  PasswordResetEnum2["PASSWORD_RESET_INPUT_PASSWORD"] = "password-reset--input-password";
  PasswordResetEnum2["PASSWORD_RESET_INPUT_CONFIRM_PASSWORD"] = "password-reset--input-confirm-password";
  PasswordResetEnum2["PASSWORD_RESET_SUBMIT_BUTTON"] = "password-reset--submit-button";
  return PasswordResetEnum2;
})(PasswordResetEnum || {});
export {
  PasswordResetEnum
};
